import React from "react";
import styles from "./HeroSlider.module.css";
import { InfoCard } from "../Experties/InfoCard";

// images
import img0 from "./application1.gif";
import img4 from "./application2.jpg";
import img1 from "./application3.jpg";
import img3 from "./application4.jpg"

const imglist = [img0, img4, img1, img3, img0, img4, img1, img3]

// sample images (use your own URLs or local images in /public)
const IMAGES = [
    "Smart Security & Surveillance",
    "Industrial AI & Automation",
    "Intelligent Retail Solutions",
    "IoT & Smart Infrastructure",
    "Smart Security & Surveillance",
    "Industrial AI & Automation",
    "Intelligent Retail Solutions",
    "IoT & Smart Infrastructure"


];
const disceibe = [
    "IoT & Smart Infrastructure",
    "Predict, inspect, and optimize — right on the factory floor.",
    "Smarter stores with instant insights and zero cloud lag.",
    "Edge AI that makes cities and devices truly intelligent.",
    "IoT & Smart Infrastructure",
    "Predict, inspect, and optimize — right on the factory floor.",
    "Smarter stores with instant insights and zero cloud lag.",
    "Edge AI that makes cities and devices truly intelligent."
]

export default function HeroSlider({ duration = 5 }) {
    // duplicate the images so the track can loop seamlessly
    const imgs = [...IMAGES, ...IMAGES];

    return (
        <section className={styles.hero}>
            <div
                className={styles.slider}
                // allow speed override from prop
                style={{ ["--duration"]: `${duration}s` }}
            >
                <div className={styles.track}>
                    {imgs.map((value, idx) => (
                        <div className={styles.slide} key={idx}>
                            <div className={styles.box}>
                                {/* <h3>{value}</h3> */}
                                <InfoCard title={value} Detail={disceibe[idx]} color={"#f59f30ff"} img={imglist[idx]} fontmultiplyer={window.innerWidth <= 700 ? 0.5 : 1} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
